export interface CosmicCode {
  id: string;
  number: number;
  symbol: string;
  name: string;
  nameJp: string;
  phrase: string;
  meaning: string;
  emotionalState: string;
  intention: string;
  forYouIf: string;
  auraColor: string;
  glowColor: string;
  element: string;
}

export const mandaraCodes: CosmicCode[] = [
  {
    id: "sol",
    number: 1,
    symbol: "☉",
    name: "Sol",
    nameJp: "太陽の核",
    phrase: "中心に還る",
    meaning: "宇宙の中心に宿る創造の炎。すべての始まりはここから生まれる。あなたの本質的な輝きを呼び覚ます聖なるコード。",
    emotionalState: "自己確信・創造力・存在感",
    intention: "今日、私は自分の光を世界に放つ",
    forYouIf: "自分の価値を見失いかけているとき。創造の炎を再点火したいとき。",
    auraColor: "#f5c842",
    glowColor: "rgba(245,200,66,0.25)",
    element: "Fire",
  },
  {
    id: "luna",
    number: 2,
    symbol: "☽",
    name: "Luna",
    nameJp: "月の引力",
    phrase: "満ちては欠ける",
    meaning: "月の満ち欠けのように、あなたの感情も波を持つ。その流れに抗わず、ただ乗ること。Lunaはその許可を与える。",
    emotionalState: "感受性・直観・受容",
    intention: "私は自分の感情の流れを信頼する",
    forYouIf: "感情の波に飲み込まれているとき。自分の感受性を恥じているとき。",
    auraColor: "#d4c8f0",
    glowColor: "rgba(212,200,240,0.2)",
    element: "Water",
  },
  {
    id: "terra",
    number: 3,
    symbol: "⊕",
    name: "Terra",
    nameJp: "大地の記憶",
    phrase: "根を張る",
    meaning: "大地はすべてを受け止める。あなたもまた、この地球に根ざした存在。Terraはその繋がりを思い出させる。",
    emotionalState: "安定・グラウンディング・安心",
    intention: "私はここに在る。大地が私を支えている",
    forYouIf: "不安定さを感じるとき。現実から浮いているとき。",
    auraColor: "#8b6f47",
    glowColor: "rgba(139,111,71,0.22)",
    element: "Earth",
  },
  {
    id: "aether",
    number: 4,
    symbol: "✦",
    name: "Aether",
    nameJp: "第五元素",
    phrase: "見えない力",
    meaning: "物質を超えた領域に存在する純粋なエネルギー。Aetherはあなたの意識を高次元へと橋渡しする。",
    emotionalState: "超越・拡張・霊的覚醒",
    intention: "私は物質を超えた存在である",
    forYouIf: "スピリチュアルな目覚めを感じているとき。より深い意味を探しているとき。",
    auraColor: "#c9a84c",
    glowColor: "rgba(201,168,76,0.22)",
    element: "Aether",
  },
  {
    id: "ignis",
    number: 5,
    symbol: "△",
    name: "Ignis",
    nameJp: "意志の炎",
    phrase: "燃え続ける",
    meaning: "消えることのない意志の炎。困難の中でも輝き続ける力。Ignisはあなたの内なる戦士を呼び覚ます。",
    emotionalState: "意志力・情熱・勇気",
    intention: "私の炎は何があっても消えない",
    forYouIf: "諦めそうになっているとき。情熱を取り戻したいとき。",
    auraColor: "#e8724a",
    glowColor: "rgba(232,114,74,0.22)",
    element: "Fire",
  },
  {
    id: "aqua",
    number: 6,
    symbol: "▽",
    name: "Aqua",
    nameJp: "流れの知恵",
    phrase: "抵抗しない",
    meaning: "水は岩を避けず、その周りを流れる。Aquaはあなたに柔軟性と適応の知恵を授ける。",
    emotionalState: "柔軟性・流れ・適応力",
    intention: "私は流れに乗り、最善の道を見つける",
    forYouIf: "状況に抵抗しているとき。コントロールを手放せないとき。",
    auraColor: "#4a9eba",
    glowColor: "rgba(74,158,186,0.2)",
    element: "Water",
  },
  {
    id: "ventus",
    number: 7,
    symbol: "∿",
    name: "Ventus",
    nameJp: "風の使者",
    phrase: "変化を運ぶ",
    meaning: "風は見えないが、その存在は感じられる。Ventusはあなたに変化への開放性と自由をもたらす。",
    emotionalState: "自由・変化・コミュニケーション",
    intention: "私は変化を恐れず、新しい風を迎える",
    forYouIf: "変化を恐れているとき。自由を求めているとき。",
    auraColor: "#a8d4c0",
    glowColor: "rgba(168,212,192,0.2)",
    element: "Air",
  },
  {
    id: "lux",
    number: 8,
    symbol: "✧",
    name: "Lux",
    nameJp: "光の源泉",
    phrase: "闇の中の光",
    meaning: "最も深い闇の中でこそ、光は最も輝く。Luxはあなたの内なる光を、どんな状況でも守り続ける。",
    emotionalState: "希望・明晰さ・内なる光",
    intention: "私の内側には、消えることのない光がある",
    forYouIf: "希望を失いかけているとき。暗闇の中にいると感じるとき。",
    auraColor: "#f0e6c0",
    glowColor: "rgba(240,230,192,0.22)",
    element: "Light",
  },
  {
    id: "umbra",
    number: 9,
    symbol: "◐",
    name: "Umbra",
    nameJp: "影の統合",
    phrase: "影を抱く",
    meaning: "光があれば影がある。Umbraはあなたの影の部分を否定せず、統合することで完全な自己へと導く。",
    emotionalState: "統合・受容・完全性",
    intention: "私は自分のすべての側面を受け入れる",
    forYouIf: "自分の一部を否定しているとき。完璧でなければと感じるとき。",
    auraColor: "#6b5b7a",
    glowColor: "rgba(107,91,122,0.22)",
    element: "Shadow",
  },
  {
    id: "kronos",
    number: 10,
    symbol: "⧗",
    name: "Kronos",
    nameJp: "時の守護者",
    phrase: "今この瞬間",
    meaning: "過去は変えられず、未来はまだ来ていない。Kronosはあなたを今この瞬間に引き戻し、現在の力を思い出させる。",
    emotionalState: "現在・集中・マインドフルネス",
    intention: "私は今この瞬間に完全に存在する",
    forYouIf: "過去や未来に囚われているとき。今を生きられていないとき。",
    auraColor: "#c0a882",
    glowColor: "rgba(192,168,130,0.2)",
    element: "Time",
  },
  {
    id: "cosmos",
    number: 11,
    symbol: "⊛",
    name: "Cosmos",
    nameJp: "宇宙の秩序",
    phrase: "すべては繋がる",
    meaning: "あなたは宇宙の一部であり、宇宙はあなたの一部。Cosmosはその壮大な繋がりを体感させる。",
    emotionalState: "一体感・宇宙意識・調和",
    intention: "私は宇宙と一体である",
    forYouIf: "孤独を感じるとき。自分が小さく感じるとき。",
    auraColor: "#8ab4d4",
    glowColor: "rgba(138,180,212,0.2)",
    element: "Cosmos",
  },
  {
    id: "anima",
    number: 12,
    symbol: "♡",
    name: "Anima",
    nameJp: "魂の愛",
    phrase: "愛から始まる",
    meaning: "すべての創造は愛から始まる。Animaはあなたの心の中心にある純粋な愛の炎を呼び覚ます。",
    emotionalState: "愛・慈悲・繋がり",
    intention: "私は愛から行動し、愛を受け取る",
    forYouIf: "愛することを恐れているとき。心を閉じているとき。",
    auraColor: "#d4788a",
    glowColor: "rgba(212,120,138,0.2)",
    element: "Love",
  },
  {
    id: "nexus",
    number: 13,
    symbol: "⬡",
    name: "Nexus",
    nameJp: "交差点",
    phrase: "出会いの必然",
    meaning: "すべての出会いには意味がある。Nexusはあなたの人生における重要な交差点を照らし、その意味を明かす。",
    emotionalState: "繋がり・シンクロニシティ・目的",
    intention: "私の人生のすべての出会いは必然である",
    forYouIf: "人間関係に迷っているとき。出会いの意味を探しているとき。",
    auraColor: "#7ab88a",
    glowColor: "rgba(122,184,138,0.2)",
    element: "Connection",
  },
  {
    id: "vortex",
    number: 14,
    symbol: "◎",
    name: "Vortex",
    nameJp: "引力の渦",
    phrase: "引き寄せる",
    meaning: "あなたが放つエネルギーは、同じ周波数のものを引き寄せる。Vortexはその引力を最大化する。",
    emotionalState: "引き寄せ・豊かさ・磁力",
    intention: "私は望むものを自然に引き寄せる",
    forYouIf: "望むものが手に入らないと感じるとき。引き寄せの力を高めたいとき。",
    auraColor: "#d4a84c",
    glowColor: "rgba(212,168,76,0.25)",
    element: "Magnetism",
  },
  {
    id: "zenith",
    number: 15,
    symbol: "△△",
    name: "Zenith",
    nameJp: "頂点の意識",
    phrase: "最高点へ",
    meaning: "あなたの可能性の頂点。Zenithはあなたが到達できる最高の状態を示し、そこへの道を照らす。",
    emotionalState: "達成・卓越・最高の自己",
    intention: "私は自分の最高の可能性を体現する",
    forYouIf: "自分の限界を超えたいとき。最高の自分になりたいとき。",
    auraColor: "#e8c84a",
    glowColor: "rgba(232,200,74,0.22)",
    element: "Peak",
  },
  {
    id: "nadir",
    number: 16,
    symbol: "▽▽",
    name: "Nadir",
    nameJp: "深淵の知恵",
    phrase: "底から見える",
    meaning: "最も深い場所からしか見えない真実がある。Nadirはあなたの最も困難な経験の中に宿る知恵を引き出す。",
    emotionalState: "深さ・知恵・変容",
    intention: "私の最も深い経験が、最大の知恵をもたらす",
    forYouIf: "困難な時期を経験しているとき。痛みの中に意味を見出したいとき。",
    auraColor: "#5a4a6a",
    glowColor: "rgba(90,74,106,0.25)",
    element: "Depth",
  },
  {
    id: "aurora",
    number: 17,
    symbol: "≋",
    name: "Aurora",
    nameJp: "夜明けの光",
    phrase: "新しい始まり",
    meaning: "夜明けは必ず来る。Auroraはあなたに新しい始まりの可能性と、変化の美しさを思い出させる。",
    emotionalState: "希望・新生・可能性",
    intention: "今日は新しい始まりの日",
    forYouIf: "新しいスタートを切りたいとき。過去を手放して前進したいとき。",
    auraColor: "#f0a878",
    glowColor: "rgba(240,168,120,0.2)",
    element: "Dawn",
  },
  {
    id: "eclipse",
    number: 18,
    symbol: "◉",
    name: "Eclipse",
    nameJp: "変容の瞬間",
    phrase: "隠れた力",
    meaning: "日食の瞬間、普段見えないものが現れる。Eclipseはあなたの隠れた力と、変容の臨界点を示す。",
    emotionalState: "変容・隠れた力・転換点",
    intention: "私の隠れた力が今、目覚める",
    forYouIf: "人生の転換点にいるとき。隠れた才能を開花させたいとき。",
    auraColor: "#c0784a",
    glowColor: "rgba(192,120,74,0.22)",
    element: "Transformation",
  },
  {
    id: "meridian",
    number: 19,
    symbol: "⊞",
    name: "Meridian",
    nameJp: "経絡の流れ",
    phrase: "エネルギーの道",
    meaning: "身体の中を流れる生命エネルギー。Meridianはその流れを整え、あなたの生命力を最大化する。",
    emotionalState: "活力・健康・エネルギー",
    intention: "私の生命エネルギーは自由に流れている",
    forYouIf: "疲れやエネルギー不足を感じるとき。身体との繋がりを取り戻したいとき。",
    auraColor: "#78c890",
    glowColor: "rgba(120,200,144,0.2)",
    element: "Life Force",
  },
  {
    id: "solstice",
    number: 20,
    symbol: "⊙",
    name: "Solstice",
    nameJp: "至点の力",
    phrase: "極点に立つ",
    meaning: "夏至と冬至、極点の力。Solsticeはあなたの人生の極点において、最大の力を引き出す。",
    emotionalState: "力・極致・完全な表現",
    intention: "私は今、自分の力の頂点にいる",
    forYouIf: "自分の力を最大限に発揮したいとき。重要な決断の前に。",
    auraColor: "#f0d060",
    glowColor: "rgba(240,208,96,0.22)",
    element: "Solstice",
  },
  {
    id: "equinox",
    number: 21,
    symbol: "⊜",
    name: "Equinox",
    nameJp: "均衡の点",
    phrase: "バランスの美",
    meaning: "昼と夜が等しくなる瞬間。Equinoxはあなたの人生のあらゆる側面に均衡をもたらす。",
    emotionalState: "バランス・調和・均衡",
    intention: "私の人生はあらゆる面で調和している",
    forYouIf: "人生のバランスを取り戻したいとき。何かに偏りすぎているとき。",
    auraColor: "#a8c8a0",
    glowColor: "rgba(168,200,160,0.2)",
    element: "Balance",
  },
  {
    id: "apogee",
    number: 22,
    symbol: "⌖",
    name: "Apogee",
    nameJp: "遠点の視野",
    phrase: "距離が見せる",
    meaning: "最も遠い点から見ると、全体像が見える。Apogeeはあなたに俯瞰の視点と、大局的な知恵を授ける。",
    emotionalState: "俯瞰・客観性・大局観",
    intention: "私は全体を見渡し、最善の道を選ぶ",
    forYouIf: "物事に近すぎて見えなくなっているとき。客観的な視点が必要なとき。",
    auraColor: "#90a8c8",
    glowColor: "rgba(144,168,200,0.2)",
    element: "Perspective",
  },
  {
    id: "perigee",
    number: 23,
    symbol: "⌗",
    name: "Perigee",
    nameJp: "近点の深さ",
    phrase: "深く潜る",
    meaning: "最も近い点では、細部が見える。Perigeeはあなたに深い集中力と、本質への洞察をもたらす。",
    emotionalState: "集中・深さ・本質",
    intention: "私は本質に集中し、深く理解する",
    forYouIf: "表面的なことに振り回されているとき。本質を見極めたいとき。",
    auraColor: "#b8906a",
    glowColor: "rgba(184,144,106,0.2)",
    element: "Focus",
  },
  {
    id: "omega",
    number: 24,
    symbol: "Ω",
    name: "Omega",
    nameJp: "完成の印",
    phrase: "すべては完全",
    meaning: "終わりは新しい始まり。Omegaはあなたの旅の完成を祝い、次のサイクルへの扉を開く。",
    emotionalState: "完成・感謝・次のサイクル",
    intention: "私の旅は完全であり、次の扉が開く",
    forYouIf: "何かを完成させたとき。新しいサイクルを始める前に。",
    auraColor: "#d4b890",
    glowColor: "rgba(212,184,144,0.22)",
    element: "Completion",
  },
  {
    id: "genesis",
    number: 25,
    symbol: "∞",
    name: "Genesis",
    nameJp: "創造の源",
    phrase: "始まりの前",
    meaning: "すべての創造の前に存在する無限の可能性。Genesisはあなたを創造の源泉に繋げ、無限の可能性を開く。",
    emotionalState: "無限・可能性・創造の源",
    intention: "私は無限の可能性から創造する",
    forYouIf: "新しいことを始めたいとき。可能性を感じられないとき。",
    auraColor: "#c9a84c",
    glowColor: "rgba(201,168,76,0.28)",
    element: "Infinity",
  },
];
